// extracted by mini-css-extract-plugin
module.exports = {"label":"_0b5bbcb","search":"_0900fdf","inputWrapper":"_78ba148","input":"_498e3b8","iconWrapper":"_67d683d","clearIcon":"_0bf03cc","searchIcon":"_910cbfa"};